import React from 'react';
import { Link } from '@ha/dsl';

function Terms() {
  return (
    <ul>
      <li>
        Eine Rückerstattung erfolgt nicht bei sonstigen Umständen, insbesondere
        nicht: bei Unterkünften, die nicht dem Geschmack entsprechen; bei
        Unterkünften, die nicht den religiösen Ansichten entsprechen
        (einschließlich des Zusammenlebens mit Menschen eines anderen
        Geschlechts); bei Unterkünften, die schmutzig sind; bei Unterkünften,
        bei denen sich im Nachhinein herausstellt, dass sie sich in unsicheren
        Stadtteilen befinden; bei Unterkünften mit Lärmbeschwerden; bei
        Unterkünften, die aus medizinischen Gründen für den Mieter ungeeignet
        sind; bei Unterkünften, die eine geringfügige Fehlfunktion aufweisen,
        die nicht im Voraus hätte bekannt sein können; wenn der Mieter aufgrund
        von Planänderungen, Reisezeitverzögerungen, Krankheit oder einer
        Doppelbuchung daran gehindert ist, zur Unterkunft zu kommen; wenn der
        Mieter das Problem nicht innerhalb der ersten 48 Stunden nach dem auf
        der Plattform registrierten Einzugsdatum meldet.
      </li>
      <li>
        <p>
          Allgemeine Geschäftsbedingungen (AGB) für die Nutzung der
          Kurzzeitwohnungsplattform auf{' '}
          <Link to="https://housinganywhere.com" kind="mint-underline">
            housinganywhere.com
          </Link>
        </p>
        <p>
          <i>(zuletzt aktualisiert: 17. März 2020)</i>
        </p>
        <h4>
          Artikel 1: Geltungsbereich, Änderung der Allgemeinen
          Geschäftsbedingungen
        </h4>
        <ol>
          <li>
            Die nachstehenden Allgemeinen Geschäftsbedingungen (AGB) gelten für
            die Nutzung der Plattform www.housinganywhere.com (auch als
            „Plattform“ bezeichnet). Dies ist ein Service der Housing Anywhere
            BV („Housing Anywhere“ oder „wir“).
          </li>
          <li>
            Im Falle eines Konfliktes gelten stets die englischen Allgemeinen
            Geschäftsbedingungen.
          </li>
          <li>
            „Benutzer“ im Sinne dieser Allgemeinen Geschäftsbedingungen
            bezeichnet natürliche und juristische Personen, die entweder eine
            Anzeige für eine Unterkunft auf der Plattform veröffentlicht oder
            auf eine Anzeige für eine Unterkunft geantwortet haben.
          </li>
          <li>
            Kunden von Housing Anywhere sind Bildungseinrichtungen. Sie
            abonnieren eine Mitgliedschaft auf der Plattform, um ihren Studenten
            diese Plattform als Wohnmöglichkeit anzubieten.
          </li>
          <li>
            Housing Anywhere bietet die Nutzung seiner Plattform, insbesondere
            die Nutzung der Datenbank, ausschließlich auf der Grundlage dieser
            Allgemeinen Geschäftsbedingungen an.
          </li>
          <li>
            Durch die Nutzung unserer Dienste stimmen die Benutzer der
            Gültigkeit dieser Allgemeinen Geschäftsbedingungen zu.
          </li>
          <li>
            Durch die Nutzung unserer Dienste bestätigen Benutzer, dass sie die
            nationalen Gesetze und Vorschriften ihres Landes in Bezug auf
            Vermietung und Untervermietung einhalten.
          </li>
          <li>
            Housing Anywhere behält sich das Recht vor, die Allgemeinen
            Geschäftsbedingungen zukünftig zu ändern. Die Änderungen werden erst
            Teil der Vereinbarung, wenn der Benutzer diesen Änderungen zustimmt.
            Dazu ist es ausreichend, dass Housing Anywhere die neue Fassung der
            Allgemeinen Geschäftsbedingungen an die E-Mail-Adresse sendet, die
            der Benutzer zu Informationszwecken angegeben hat. Widerspricht der
            Nutzer den Änderungen der Allgemeinen Geschäftsbedingungen nicht
            innerhalb einer Woche, gilt die Zustimmung als erteilt.
          </li>
          <li>
            Widersprüchliche Allgemeine Geschäftsbedingungen des Benutzers haben
            keine Auswirkung (ungeachtet Punkt 2.5), selbst wenn Housing
            Anywhere diesen nicht widerspricht.
          </li>
        </ol>
        <h4>
          Artikel 2: Leistung von Housing Anywhere, Leistung von Anbietern
        </h4>
        <ol>
          <li>
            Bei der Plattform handelt es sich um einen Online-Marktplatz, auf
            dem Benutzer Zimmer oder andere Arten von Unterkünften
            („Unterkünfte“) anbieten und mieten können.
          </li>
          <li>
            Auf www.Housing Anywhere bietet Housing Anywhere eine Plattform, auf
            der Benutzer miteinander kommunizieren und Verträge abschließen
            können. Housing Anywhere selbst bietet keine Unterkünfte an. Es
            fungiert lediglich als Vermittler für den Abschluss von Verträgen
            zwischen Benutzern.
          </li>
          <li>
            Housing Anywhere weist darauf hin, dass die Verwendung eines
            Mietvertrags zwischen Anbieter und Mieter dringend empfohlen wird.
            Da Housing Anywhere der Nutzung eines Mietvertrags eine hohe
            Bedeutung beimisst, bietet sie Anbietern und Mietern einen
            Mustermietvertrag an. Durch das Anbieten einer Unterkunft auf
            Housing Anywhere stimmt der Anbieter der Anwendung des
            Mustermietvertrags von Housing Anywhere zu, es sei denn, der
            Anbieter erklärt ausdrücklich, dass ein anderer Mietvertrag gilt,
            und der Mieter diesem anderen Mietvertrag zustimmt. Housing Anywhere
            bietet den Benutzern den Mustermietvertrag lediglich der
            Bequemlichkeit halber an. Die Anwendbarkeit des Mietvertrags erfolgt
            auf Wahl des Mieters und Anbieters. Housing Anywhere kann daher
            niemals für Mängel im Mustermietvertrag oder für Schäden
            verantwortlich gemacht werden, die sich aus der Verwendung des
            Mustermietvertrags ergeben.
          </li>
          <li>
            Mietverträge werden ausschließlich zwischen dem Benutzer, der die
            Unterkunft bereitstellt („Anbieter“) und dem Benutzer, der die
            Unterkunft mietet („Mieter“), geschlossen. Housing Anywhere selbst
            ist keine Partei der zwischen den Benutzern der Website
            geschlossenen Mietverträge. Housing Anywhere ist jedoch berechtigt,
            als Vertreter des Anbieters zu fungieren, der zum Abschluss der
            Vereinbarungen sowie zum Abschluss der Vereinbarungen in dessen
            Namen befugt ist. Der Anbieter und die Mieter sind jedoch selbst für
            die Erfüllung ihrer eigenen vertraglichen Verpflichtungen
            verantwortlich. Im Falle eines Verzugs muss dies zwischen den
            Benutzern ausgehandelt werden. Housing Anywhere speichert und
            überträgt zu diesem Zweck die Kontaktdaten beider Parteien.
          </li>
          <li>
            Housing Anywhere prüft nicht die Rechtmäßigkeit, Richtigkeit oder
            Vollständigkeit von auf der Plattform veröffentlichten Angeboten
            oder Benutzerinhalten, und diese geben nicht die Ansichten von
            Housing Anywhere wieder. Housing Anywhere ist nicht verantwortlich
            für Angebote oder Inhalte Dritter.
          </li>
          <li>
            Anbieter können ihre eigenen Allgemeinen Geschäftsbedingungen auf
            die von ihnen vermietete Unterkunft anwenden, welche die Allgemeinen
            Geschäftsbedingungen von Housing Anywhere nicht berühren.
          </li>
          <li>
            Anbieter und Mieter sind für die Einhaltung der Bestimmungen des
            öffentlichen Rechts verantwortlich, einschließlich der kommunalen
            Vorschriften über die Vermietung von Immobilien.
          </li>
          <li>
            Die Anbieter sind im Falle einer Untervermietung für die Erlaubnis
            ihres Vermieters verantwortlich.
          </li>
          <li>
            Die Anbieter sind für die Einholung aller erforderlichen Dokumente
            zur Vermietung der Wohnung verantwortlich. Diese Dokumente umfassen
            insbesondere Genehmigungen für die (Unter-) Miete vom Vermieter oder
            der Gemeinde sowie (Unter-) Mietverträge.
          </li>
          <li>
            Durch die Zustimmung zu diesen Allgemeinen Geschäftsbedingungen
            (AGB) erklärt der Anbieter, dass er die Erlaubnis des Vermieters
            (Privat, Makler oder Wohngenossenschaft) hat, das Zimmer/die
            Immobilie zu vermieten, wie unter Punkt 8 dargelegt, sowie dass er
            alle erforderlichen Dokumente eingeholt, wie unter Punkt 9
            dargelegt, und gegebenenfalls seine Mitbewohner informiert hat.
          </li>
        </ol>
        <h4>
          Artikel 3: Registrierung, Umsetzung der Nutzungsvereinbarung,
          Vertragserklärungen
        </h4>
        <ol>
          <li>
            Die Registrierung von Benutzern ist zur Nutzung von Housing Anywhere
            erforderlich. Anbieter registrieren sich, wenn sie ihr Zimmer online
            stellen. Mieter registrieren sich, wenn sie auf eine Anzeige für ein
            Zimmer antworten. Die Registrierung ist kostenlos und setzt die
            Annahme der Allgemeinen Geschäftsbedingungen von Housing Anywhere
            durch die Benutzer voraus. Die Benutzervereinbarung zwischen Housing
            Anywhere und dem Benutzer entsteht mit der Annahme der Allgemeinen
            Geschäftsbedingungen.
          </li>
          <li>
            Die Registrierung steht nur geschäftsfähigen natürlichen Personen,
            juristischen Personen und Personengesellschaften zur Verfügung. Die
            Registrierung einer juristischen Person oder Personengesellschaft
            darf nur von einer natürlichen Person mit Vertretungsbefugnis
            durchgeführt werden, die benannt werden muss. Bei der Registrierung
            dürfen nur Einzelpersonen als Eigentümer des Benutzerkontos
            angegeben werden (d. h. keine verheirateten Paare oder Familien).
          </li>
          <li>
            Die Registrierung als Anbieter ist nur für Personen mit einem
            aktivierten Studenten-E-Mail-Konto, Personen mit einem von Housing
            Anywhere bereitgestellten Gutschein/Code oder einem aktivierten
            Vermieterkonto möglich.
          </li>
          <li>
            Bei der Registrierung verpflichtet sich der Benutzer, genaue,
            aktuelle und vollständige Informationen gemäß dem
            Registrierungsformular bereitzustellen, insbesondere Vor- und
            Nachnamen, aktuelle Adresse (kein Postfach), eine gültige
            E-Mail-Adresse und ggf. den Namen des Unternehmens und einen
            Bevollmächtigten. Die Daten müssen jederzeit aktuell und korrekt
            sein. Mehrfachregistrierungen unter verschiedenen Mitgliedsnamen
            sind verboten. Bei der Registrierung wählt der Benutzer ein Passwort
            für seine E-Mail-Adresse.
          </li>
          <li>
            Der Benutzer kann vertragliche Erklärungen an seine angegebene
            E-Mail-Adresse erhalten.
          </li>
        </ol>
        <h4>
          Artikel 4: Pflichten des Benutzers, Benutzerkonto, Systemintegrität
        </h4>
        <ol>
          <li>
            Der Benutzer ist allein verantwortlich für alle Inhalte, die er auf
            der Plattform platziert. In seiner Beziehung zu HousingAnywhere.com
            verpflichtet er sich, keine illegalen Inhalte auf der Plattform zu
            platzieren und illegale Handlungen zu unterlassen.
          </li>
          <li>
            Der Anbieter ist dafür verantwortlich, dass die von ihm angebotene
            Unterkunft korrekt und vollständig beschrieben wird. Er muss
            zumindest die Informationen in den erforderlichen Feldern von
            HousingAnywhere.com angeben, damit die Unterkunft und das Angebot
            mit ausreichender Genauigkeit beschrieben werden.
          </li>
          <li>
            Der Benutzer stimmt zu, dass alle hinzugefügten Fotos authentisch
            sein und die Räume realistisch darstellen müssen. Bildreplikationen
            von anderen Websites werden ohne vorherige Ankündigung gelöscht und
            der Benutzer von der Plattform entfernt oder deaktiviert.
          </li>
          <li>
            Darüber hinaus steht es dem Anbieter frei, weitere Bedingungen wie
            die Höhe der Kaution, die Kosten für die Endreinigung usw.
            festzulegen. Der Benutzer verpflichtet sich, die Informationen in
            seinem Benutzerkonto jederzeit zu aktualisieren und korrekt
            anzugeben, d. h. sie im Falle einer Änderung sofort zu berichtigen
            oder das Zimmer von der Plattform zu löschen, falls Mieter und
            Anbieter eine Vermietung vereinbart zu haben. Ein Benutzerkonto ist
            persönlich und kann daher nicht auf eine andere Person übertragen
            werden.
          </li>
          <li>
            Der Benutzer verpflichtet sich, sein Benutzerkonto nur selbst zu
            verwenden und sein Passwort geheim zu halten.
          </li>
          <li>
            Der Benutzer haftet gegenüber HousingAnywhere.com für sämtliche
            Handlungen, die mit seinem Benutzerkonto ausgeführt werden, es sei
            denn, der Benutzer ist nicht für den Missbrauch seines
            Benutzerkontos verantwortlich.
          </li>
          <li>
            Sobald dem Benutzer bekannt ist, dass Dritte Zugriff auf seine
            Benutzerdaten haben oder auf andere Weise Zugriff auf sein
            Benutzerkonto erhalten haben, muss er HousingAnywhere.com
            unverzüglich darüber informieren. HousingAnywhere.com ist
            berechtigt, das Benutzerkonto zu sperren, bis die Situation geklärt
            ist.
          </li>
          <li>
            HousingAnywhere.com berechnet ohne vorherige Ankündigung den Preis
            für die Buchungsgebühr und entfernt oder deaktiviert den Zugriff des
            Benutzers, der persönliche Kontakte sendet, veröffentlicht oder
            überträgt, welche die andere Partei von der Plattform wegführen
            würden (z. B. persönliches Bankkonto, Telefonnummer, E-Mail usw.).
          </li>
          <li>
            Jeder Benutzer muss unabhängig die Identität seines jeweiligen
            Vertragspartners überprüfen (der Mieter im Falle des Anbieters oder
            der Anbieter im Falle des Mieters). HousingAnywhere.com übernimmt
            keine Haftung für die Richtigkeit der auf der Plattform eingegebenen
            Benutzerkontaktinformationen.
          </li>
          <li>
            Der Benutzer verpflichtet sich, seine Systeme und Programme im
            Zusammenhang mit der Nutzung des Angebots von HousingAnywhere.com so
            einzurichten, dass die Sicherheit, Integrität und Verfügbarkeit der
            von HousingAnywhere.com zur Bereitstellung seiner Dienste
            eingerichteten Systeme nicht beeinträchtigt wird. Benutzer dürfen
            von HousingAnywhere.com generierte Inhalte nicht blockieren,
            umschreiben oder ändern oder auf andere Weise eingreifen, die gegen
            den Zweck der Benutzervereinbarung verstößt. HousingAnywhere.com ist
            berechtigt, die zur Gewährleistung der Systemintegrität aller
            Parteien erforderlichen Maßnahmen gemäß Punkt 15 festzulegen.
          </li>
          <li>
            Benutzer dürfen keine Adressen, Kontaktdaten oder E-Mail-Adressen
            verwenden, die sie durch die Nutzung der Website für andere Zwecke
            als für die vertragliche Kommunikation erhalten. Insbesondere dürfen
            diese Daten nicht an Unbefugte weitergegeben oder zum Versenden von
            Werbung verwendet werden, es sei denn, der betreffende Benutzer hat
            zuvor ausdrücklich seine Zustimmung erteilt.
          </li>
          <li>
            Der Benutzer darf keine Massennachrichten mit demselben Inhalt über
            die Plattform senden. Jegliche Spam- oder ähnliche
            Belästigungsmaßnahmen gegenüber anderen Benutzern oder Dritten sind
            untersagt.
          </li>
          <li>
            Jeder Benutzer ist selbst für die Archivierung sämtlicher
            Informationen verantwortlich, die auf der Website angezeigt und von
            HousingAnywhere.com gespeichert werden können und zur
            Beweissicherung, Buchhaltung usw. auf einem von HousingAnywhere.com
            unabhängigen Speichermedium erforderlich sind.
          </li>
          <li>
            HousingAnywhere.com gibt keine Kontaktdaten seiner Benutzer an
            Dritte weiter, außer an unsere Partnerinstitutionen oder wenn das
            Gesetz dies vorschreibt. Die Partnerinstitutionen (hauptsächlich
            Universitäten oder andere Bildungseinrichtungen) können
            HousingAnywhere.com um eine Übersicht über die in ihrer Stadt
            vermieteten Zimmer bitten. Der Zweck dieses Informationsaustauschs
            besteht darin, dass die Partnerinstitutionen die Nachfrage nach
            Zimmern in ihrer Stadt besser prognostizieren und mögliche
            Missbräuche von Studenten überprüfen können.
          </li>
          <li>
            Im Falle eines Verstoßes eines Nutzers gegen diese Allgemeinen
            Geschäftsbedingungen ist HousingAnywhere.com berechtigt, sein
            virtuelles Hausrecht auszuüben. HousingAnywhere.com kann den
            betreffenden Benutzer von der Nutzung seiner Dienste ausschließen,
            den von ihm verwendeten Inhalt löschen oder andere Maßnahmen im
            Sinne von Punkt 13 ergreifen. HousingAnywhere.com wird rechtliche
            Schritte einleiten, um seine legitimen Rechte auf Unterlassung und
            Entschädigung auszuüben.
          </li>
        </ol>
        <h4>Artikel 5: Umgang mit Inhalten und Rechten</h4>
        <ol>
          <li>
            Im Rahmen der Funktionalität der Plattform können Anbieter ihre
            Inhalte potenziellen Mietern über eine Vielzahl von Medien
            präsentieren. Bestimmte Regeln müssen eingehalten werden, um
            sicherzustellen, dass die verschiedenen Medien legal verwendet
            werden, damit weder der Benutzer noch Housing Anywhere haftbar
            gemacht werden können. Diese Regeln ergeben sich beispielsweise aus
            Gesetzen zum Schutz von Urheberrechten und Marken zusätzlich zu
            diesen Allgemeinen Geschäftsbedingungen.
          </li>
          <li>
            Housing Anywhere speichert für den Benutzer die von ihm
            hochgeladenen Multimedia-Inhalte (Bilder, Text usw.) oder richtet
            lediglich den erforderlichen Speicherplatz und Zugriff darauf ein.
            Die Benutzer haften allein für den von ihnen auf Housing Anywhere
            hochgeladenen Inhalt und stellen Housing Anywhere von allen daraus
            resultierenden Ansprüchen Dritter frei. Diese Freistellung umfasst
            insbesondere auch die Kosten einer angemessenen Strafverfolgung und
            Rechtsverteidigung.
          </li>
          <li>
            Die Benutzer stellen sicher, dass der hochgeladene Inhalt nicht
            gegen geltendes Recht oder gesetzliche Bestimmungen, gegen gute
            Sitten oder insbesondere gegen Rechte Dritter (Namensrechte,
            Persönlichkeitsrechte, Urheberrechte, Datenschutzrechte usw.)
            verstößt. Insbesondere verpflichten sich Benutzer, keine Inhalte
            hochzuladen, die gegen die Bestimmungen geltender Gesetze oder
            Verträge verstoßen. Der Benutzer verpflichtet sich auch, keine
            pornografischen, gewaltverherrlichenden oder volksverhetzenden
            Inhalte zu verwenden. Dies gilt auch für den Versand von E-Mails und
            anderen elektronischen Kommunikationsmedien der Plattform.
          </li>
          <li>
            Durch das Hochladen von Multimedia-Inhalten übertragen Benutzer ein
            freies, widerrufliches, unbegrenztes, nicht lokales Nutzungsrecht an
            Housing Anywhere, das für die vom Benutzer auf Housing Anywhere
            hochgeladenen Multimedia-Inhalte unterlizenziert werden kann. Das
            Nutzungsrecht umfasst insbesondere das Recht, die Multimedia-Inhalte
            für die Zwecke der Plattform zu verarbeiten und der Öffentlichkeit
            offline in gedruckter oder elektronischer Form über eine
            kabelgebundene oder drahtlose Verbindung so zur Verfügung zu
            stellen, dass sie für die Öffentlichkeit an Orten und zu Zeiten
            ihrer Wahl zugänglich sind, einschließlich der Wiedergabe auf dem
            von ihnen gewählten Empfangsgerät, das den Online-Zugriff
            ermöglicht, insbesondere auf stationäre und tragbare Computer und
            mobile Handheld-Geräte wie Smartphones, Tablets und ähnliche Geräte.
            Zu den Nutzungsrechten gehört auch das Recht, Multimedia-Inhalte,
            einschließlich Werbemittel, auf Websites der Vertragspartner von
            Housing Anywhere zu integrieren.
          </li>
          <li>
            Es steht Housing Anywhere frei, jegliche in einer Mitteilung
            enthaltenen Kommentare, Informationen, Bilder oder Ideen, die ein
            Benutzer an Housing Anywhere sendet, ohne Entschädigung, Bestätigung
            oder Zahlung an den Benutzer zu jedwedem Zweck zu verwenden,
            insbesondere für die Entwicklung, Herstellung und Vermarktung von
            Produkten und Diensten sowie die Erstellung, Änderung oder
            Verbesserung der Dienste oder der Website oder anderer Produkte oder
            Dienste. Um Missverständnisse auszuschließen, wird darauf
            hingewiesen, dass alle diese Informationen von Housing Anywhere als
            nicht vertraulich und nicht urheberrechtlich geschützt eingestuft
            werden. Der Benutzer erklärt sich damit einverstanden, dass diese
            Informationen von Housing Anywhere ohne jegliche Einschränkung
            verwendet werden können.
          </li>
          <li>
            Der Benutzer erklärt sich ausdrücklich damit einverstanden, dass
            Housing Anywhere alle zwischen Benutzern gesendeten Nachrichten
            lesen kann. Housing Anywhere kann diese Nachrichten lesen, um die
            Benutzererfahrung zu verbessern, Konflikte zwischen Benutzern zu
            lösen oder aus anderen Gründen, die Housing Anywhere für angemessen
            hält.
          </li>
          <li>
            Der Benutzer erklärt sich damit einverstanden, dass Housing Anywhere
            die von ihm auf der Website veröffentlichten Informationen erneut
            veröffentlichen und verwenden kann, ohne den Benutzer als Quelle
            dieser Informationen und/oder Ersteller solcher Inhalte zu
            bestätigen. Im Allgemeinen wird Housing Anywhere jedoch versuchen,
            einen Link zurück zur Benutzerseite bereitzustellen, wenn Inhalte
            auf Websites Dritter, wie Facebook oder einem unserer
            Vertragspartner, veröffentlicht werden. Der Benutzer verzichtet
            hiermit unwiderruflich auf alle Urheberpersönlichkeitsrechte an
            Inhalten, die auf der Website platziert werden.
          </li>
          <li>
            Der Benutzer gestattet Housing Anywhere ausdrücklich, das Profilbild
            des Benutzers (Facebook) auf seiner Website www.housinganywhere.com
            zu verwenden und anzuzeigen.
          </li>
          <li>
            Der über Housing Anywhere angebotene Inhalt ist urheberrechtlich
            geschützt. Die Plattform wird im Allgemeinen von einer natürlichen
            Person über einen Webbrowser einzeln aufgerufen und verwendet. Die
            Verwendung von Technologien wie Web Spiders, Crawlern oder ähnlichen
            Programmen, deren Zweck nicht nur die Indizierung von Inhalten,
            sondern auch dem Massenzugriff, sowie dem Speichern von Inhalten der
            Plattform dient, ist verboten. Dies gilt insbesondere auch für
            Technologien, die das sogenannte Screen Scraping und andere Dienste
            von Drittanbietern ermöglichen.
          </li>
          <li>
            Im Falle eines Verstoßes gegen diese Verbote und die Richtlinien
            dieser Allgemeinen Geschäftsbedingungen ist Housing Anywhere
            berechtigt, die Annahme von Inhalten zu verweigern, Inhalte sofort
            zu löschen und zu blockieren sowie die Seiten und Links zu diesen
            sofort zu löschen. In solchen Fällen hat der Benutzer kein Recht auf
            Wiederherstellung seiner Multimedia-Inhalte auf der
            Internetplattform oder Freigabe seines gelöschten Benutzerprofils.
          </li>
        </ol>
        <h4>Artikel 6: Verfügbarkeit und Änderung der Website</h4>
        <ol>
          <li>
            Der Nutzer hat keinen Rechtsanspruch auf die dauerhafte Nutzung der
            Plattform. Insbesondere ist Housing Anywhere nicht verpflichtet,
            sicherzustellen, dass die Plattform verfügbar oder jederzeit
            erreichbar ist. Housing Anywhere ist jedoch bestrebt, den Betrieb
            der Plattform möglichst störungsfrei aufrechtzuerhalten und sie
            entsprechend den Benutzeranforderungen weiterzuentwickeln.
          </li>
          <li>
            Housing Anywhere kann die Nutzung vorübergehend einschränken, wenn
            dies im Hinblick auf die Sicherheit, Integrität, Kapazitätsgrenzen
            oder die Durchführung technischer Maßnahmen (Wartungsarbeiten)
            erforderlich ist. Insbesondere berücksichtigt Housing Anywhere die
            berechtigten Interessen der Benutzer, indem es sie im Voraus
            benachrichtigt.
          </li>
        </ol>
        <h4>Artikel 7: Haftung für Websites Dritter</h4>
        <ol>
          <li>
            Die Seiten der Plattform enthalten auch Links zu Websites im
            Internet, die von Dritten unterhalten werden und deren Inhalt
            Housing Anywhere nicht bekannt ist. Housing Anywhere bietet
            lediglich Zugriff auf die Websites und übernimmt keine Verantwortung
            für den Inhalt. Die Links zu Websites von Drittanbietern dienen
            lediglich der einfacheren Navigation. Housing Anywhere unterstützt
            nicht die Ansichten, die auf den verlinkten Websites geäußert
            werden, sondern distanziert sich hiermit ausdrücklich von allen
            Inhalten auf allen Websites, auf die es auf seiner Plattform
            verlinkt.
          </li>
          <li>
            Die Eigentümer der Websites, auf die die Hyperlinks der Housing
            Anywhere-Plattform verweisen, sind allein für ihren Inhalt und die
            dort zum Verkauf angebotenen Waren oder Dienstleistungen
            verantwortlich.
          </li>
        </ol>
        <h4>
          Artikel 8: Sicherer Buchungsservice, Zahlung, Rechnung und Provision
        </h4>
        <ol>
          <li>
            Durch die Auflistung einer Unterkunft auf der Website
            HousingAnywhere.com lädt der Anbieter zur Abgabe von Angeboten ein.
            Ein anderer Benutzer kann ein Angebot zum Abschluss eines
            Mietvertrags für diese Unterkunft abgeben. Die Vereinbarung kommt
            zustande, wenn der Anbieter dieses Angebot annimmt, es sei denn, der
            Mieter zieht dieses Angebot zurück, bevor der Anbieter es annimmt.
          </li>
          <li>
            Eine Miete ist der Zeitraum, für den der Mieter die Unterkunft vom
            Anbieter mietet. Die Laufzeit eines Mietvertrags kann variieren und
            hat keine Höchst- oder Mindestdauer. Die durchschnittliche Mietdauer
            beträgt ca. 5 Monate.
          </li>
          <li>
            Nach Abschluss der Vereinbarung bietet HousingAnywhere.com den
            Mietern eine Buchungsmethode über die Website von
            HousingAnywhere.com an, auf der HousingAnywhere.com das Geld bis 48
            Stunden nach Beginn des Mietvertrags aufbewahrt. Nach dieser Frist
            überweist HousingAnywhere.com die Mietzahlung an den Anbieter.
            HousingAnywhere.com fungiert als Treuhänder, um Betrug zu vermeiden.
          </li>
          <li>
            Die Nutzung des von HousingAnywhere.com angebotenen sicheren
            Buchungsdienstes ist für alle Benutzer der Website obligatorisch.
            Der Anbieter der Unterkunft ist für die Ausführung der Zahlung der
            ersten Monatsmiete über HousingAnywhere.com verantwortlich.
          </li>
          <li>
            Falls eine Vereinbarung getroffen wurde und die Parteien das
            Zahlungsverfahren fortsetzen, erhält der Mieter von
            HousingAnywhere.com einen Zahlungslink, über den die Zahlung an
            HousingAnywhere.com überwiesen wird. Die Zahlung wird auf ein
            sicheres externes Bankkonto überwiesen. 48 Stunden nach dem auf der
            Plattform registrierten Einzugsdatum ordnet HousingAnywhere.com die
            Überweisung der Miete an den Anbieter und die Bearbeitungsgebühr von
            HousingAnywhere.com an, sofern der Mieter keine Änderungen verlangt.
          </li>
          <li>
            Stornierungsbedingungen:
            <ol>
              <li>
                HousingAnywhere.com hat strenge Stornierungsbedingungen, nachdem
                eine Buchung bestätigt wurde. Nach Abschluss einer Vereinbarung
                ist der Mieter zur Zahlung des fälligen Betrags verpflichtet.
                Für den Fall, dass der Mieter beschließt, die Unterkunft nach
                Abschluss einer Vereinbarung nicht zu nutzen, erfolgt keine
                Rückerstattung, es sei denn, es gibt berechtigte Gründe für eine
                Rückerstattung gemäß Artikel 8.7 unserer Allgemeinen
                Geschäftsbedingungen.
              </li>
              <li>
                Wenn der Mieter nicht erscheint oder die Unterkunft nicht in
                Anspruch nimmt, überträgt HousingAnywhere.com die erste
                Monatsmiete an den Inserenten, um den Inserenten für den Verlust
                eines unbezogenen Zimmers zu entschädigen. Storniert ein Mieter
                eine Buchung nach dem Tag der Buchung aus anderen Gründen als
                höherer Gewalt, behält Housing Anywhere die Buchungsgebühr als
                Entschädigung für seine Dienste ein.
              </li>
              <li>
                HousingAnywhere.com überweist die Miete 48 Stunden nach Beginn
                des auf der Plattform registrierten Mietvertrags an den
                Inserenten.
              </li>
              <li>
                HousingAnywhere.com ist nach Ablauf von 48 Stunden nicht mehr an
                der Ausführung der Vereinbarung zwischen dem Mieter und dem
                Inserenten beteiligt. Ebenso ist es nicht möglich, nach Ablauf
                dieser 48 Stunden eine Rückerstattung zu leisten, wenn der
                Mieter kein Problem mit dem Zimmer gemeldet hat.
              </li>
              <li>
                Beschließt der Mieter nach der Buchung, die Unterkunft nicht zu
                beziehen, hat er immer die Möglichkeit, den Inserenten zu
                fragen, ob er bereit ist, die erste Monatsmiete
                zurückzuerstatten. Es liegt am Inserenten, dem zuzustimmen oder
                nicht. Wenn der Inserent einer Rückerstattung der ersten
                Monatsmiete zustimmt, so muss er HousingAnywhere.com darüber in
                Kenntnis setzen. Wenn HousingAnywhere.com das Geld bereits an
                den Inserenten überwiesen hat, muss dieser das Geld direkt an
                den Mieter zurückerstatten. HousingAnywhere.com ist nicht an der
                Überweisung von Geldern zwischen dem Vermieter und dem Mieter
                beteiligt.
              </li>
            </ol>
          </li>
          <li>
            Rückerstattungsbedingungen:
            <ol>
              <li>
                Housing Anywhere bietet dem Mieter eine Rückerstattung der
                ersten Monatsmiete und der sicheren Buchungsgebühr:
                <ul>
                  <li>
                    wenn der Mieter feststellt, dass er in den
                    unwahrscheinlichen Fall eines Betrugs verwickelt war (das
                    Zimmer existiert überhaupt nicht, das Zimmer ist anders als
                    im Vertrag angegeben)
                  </li>
                  <li>
                    wenn ein vereinbartes Zimmer nicht für die Nutzung durch den
                    Mieter verfügbar ist (da z. B. bereits jemand anderes im
                    Zimmer ist)
                  </li>
                  <li>
                    bei Naturkatastrophen (Lawinen, Schneestürme, Wirbelstürme,
                    Hurrikane, Erdbeben, Überschwemmungen, Blitzeinschläge,
                    Erdrutsche)
                  </li>
                  <li>
                    bei anderen unvorhersehbaren Ereignissen (Krieg,
                    Terroranschlag, Atomkatastrophe)
                  </li>
                </ul>
                Wenn ein Mieter von mildernden Umständen betroffen ist, die ihn
                daran hindern, den auf HousingAnywhere gebuchten Ort zu
                beziehen, bewerten wir diese Fälle wie und wann sie auftreten
                und können Notfallrichtlinien für die betroffenen Gebiete
                erlassen. Wenn ein mildernder Umstand vorliegt, erhält der
                Nutzer nur die erste Monatsmiete zurückerstattet. Gegenwärtig
                haben wir mildernde Umstände auf die von Covid-19 schwer
                betroffenen Gebiete angewendet. Mehr über unsere Richtlinien
                finden Sie{' '}
                <Link
                  to="https://answers.housinganywhere.com/en/articles/3746319-coronavirus-cancellation-policy"
                  kind="mint-underline"
                >
                  hier
                </Link>
                .
              </li>
              <li>
                Dies muss HousingAnywhere.com innerhalb von 48 Stunden nach dem
                auf der Plattform registrierten Einzugsdatum mitgeteilt werden.
              </li>
              <li>
                Eine Rückerstattung erfolgt nicht bei sonstigen Umständen,
                insbesondere nicht: bei Unterkünften, die nicht dem Geschmack
                entsprechen; bei Unterkünften, die nicht den religiösen
                Ansichten entsprechen (einschließlich des Zusammenlebens mit
                Menschen eines anderen Geschlechts); bei Unterkünften, bei denen
                sich im Nachhinein herausstellt, dass sie sich in unsicheren
                Stadtteilen befinden; bei Unterkünften mit Lärmbeschwerden; bei
                Unterkünften, die aus medizinischen Gründen für den Mieter
                ungeeignet sind; bei Unterkünften, die eine geringfügige
                Fehlfunktion aufweisen, die nicht im Voraus hätte bekannt sein
                können; wenn der Mieter aufgrund von Planänderungen,
                Reisezeitverzögerungen, Krankheit oder einer Doppelbuchung daran
                gehindert ist, zur Unterkunft zu kommen.
              </li>
              <li>
                Der Mieter ist verpflichtet, HousingAnywhere.com und den
                Anbieter innerhalb von 48 Stunden nach Beginn der auf der
                Plattform registrierten Mietdauer zu informieren. Der Mieter
                muss seinen Anspruch begründen und einen visuellen Nachweis
                (Bilder, Videos) erbringen. Findet HousingAnywhere.com nach
                eigenem Ermessen den Anspruch des Mieters überzeugend, erstattet
                es dem Mieter die Miete und die von HousingAnywhere.com
                berechnete Buchungsgebühr. Wenn der Mieter HousingAnywhere.com
                nicht innerhalb von 48 Stunden nach Beginn des Mietverhältnisses
                über Probleme informiert, wird davon ausgegangen, dass der
                Mieter dem Zimmer so wie es ist zugestimmt hat.
                HousingAnywhere.com überweist dann die Zahlung der Miete an den
                Anbieter.
              </li>
              <li>
                Im Falle eines Streits zwischen Mieter und Anbieter empfiehlt
                HousingAnywhere.com den Parteien, diesen selbst zu lösen. Sollte
                sich dies als unmöglich herausstellen, können die Parteien
                HousingAnywhere.com die Informationen und möglichen Beweise im
                Zusammenhang mit dem Streit zur Verfügung stellen. Nach
                Berücksichtigung aller bereitgestellten Informationen
                entscheidet HousingAnywhere.com über den Streit, wobei die
                Entscheidung für beide Parteien bindend ist.
              </li>
              <li>
                Das Zimmer muss in sauberem Zustand an den Mieter übergeben
                werden. Wenn der Mieter ankommt und sich das Zimmer nicht in
                einem angemessenen hygienischen Zustand befindet, riskiert der
                Inserent, dass die Zahlung einbehalten und möglicherweise
                storniert wird, bis der Inserent das Problem gelöst hat. Der
                Mieter muss diese ungeeigneten Bedingungen nachweisen (d. h. mit
                einem Foto). HousingAnywhere.com entscheidet, ob dies
                signifikant genug ist, um die Zahlung einzubehalten und/oder zu
                stornieren.
              </li>
            </ol>
          </li>
          <li>
            Der Anbieter muss sicherstellen, dass:
            <ol>
              <li>
                ein korrektes IBAN-/BIC-Bankkonto angegeben wird.
                HousingAnywhere.com überweist die Miete auf das angegebene
                Bankkonto und haftet nicht, wenn dieses Bankkonto falsch ist.
                Die Verpflichtungen von HousingAnywhere.com gegenüber dem
                Anbieter erlöschen, sobald HousingAnywhere.com die Miete auf das
                vom Anbieter angegebene Bankkonto überwiesen hat. Ob dieses
                Bankkonto korrekt ist oder nicht, bleibt das Risiko des
                Anbieters und beeinträchtigt nicht die Befreiung von
                HousingAnywhere.com von seinen Verbindlichkeiten.
              </li>
              <li>
                die Beschreibung der Unterkunft und die verwendeten Bilder nicht
                gegen das Gesetz oder die Rechte Dritter verstoßen und sich nur
                auf die angebotene Unterkunft beziehen;
              </li>
              <li>
                erfolgreich gebuchte Unterkünfte entsprechend gekennzeichnet
                oder von der Plattform entfernt werden;
              </li>
              <li>
                hochgeladene Informationen keine Verweise auf Inhalte Dritter
                darstellen;
              </li>
              <li>
                er die öffentlich-rechtlichen Vorschriften einhält, insbesondere
                die Zahlungs-, Factoring- und steuerrechtlichen Pflichten, zu
                denen auch Umsatzsteuer- oder indirekte Steuerpflichten gehören
                können. Der Anbieter ist allein verantwortlich für die
                Verpflichtungen und Pflichten des Angebotsinhalts.
                HousingAnywhere.com ist berechtigt, das Angebot der Nutzer zu
                überprüfen und die entsprechenden Nachweise anzufordern;
              </li>
              <li>
                sobald ein Mieter die Anmietung der Unterkunft beantragt hat,
                der Anbieter keinen höheren Preis als den in der Originalanzeige
                angegebenen verlangen darf.
              </li>
            </ol>
          </li>
          <li>
            In Bezug auf Angebote des Nutzers:
            <ol>
              <li>
                kann jeder, der eine auf der Plattform veröffentlichte
                Unterkunft mieten möchte, über die Plattform antworten.
              </li>
              <li>
                Das Antworten auf eine Unterkunft kann nur mit dem Wunsch in
                Verbindung gebracht werden, eine Vereinbarung über die Anmietung
                einer auf www.housinganywhere.com veröffentlichten Unterkunft zu
                treffen. Alle anderen Zwecke, die nicht mit diesem Ziel in
                Einklang stehen, wie z. B. die Kontaktaufnahme mit dem Anbieter
                zu Werbezwecken, die Aufforderung an die Benutzer, ihre
                Zimmerangebote auf verschiedenen Wohnungswebsites zu
                veröffentlichen, einen Traffic zu anderen Websites zu
                generieren, die Verwendung einer automatischen Funktion oder
                manueller Prozesse zum Suchen oder Sammeln von Informationen von
                der Website oder zum Beeinträchtigen des ordnungsgemäßen
                Funktionierens der Website sind verboten.
              </li>
              <li>
                Benutzern ist es untersagt, die oben genannten Buchungs- und
                Zahlungsvorgänge, insbesondere die Bearbeitungsgebühren, zu
                umgehen.
              </li>
              <li>
                Erfolgen Antworten aus einem anderen Grund als nur zu einer
                Vereinbarung über die Anmietung einer auf
                www.housinganywhere.com aufgeführten Immobilie, die gegen den
                vorherigen Absatz verstoßen, so wird der Antwortende mit einer
                Geldstrafe von 1000 € (in Worten: eintausend Euro) pro
                gesendeter Antwort bestraft.
              </li>
            </ol>
          </li>
          <li>
            Der Zahlungsvorgang erfolgt nach den folgenden Bestimmungen:
            <ol>
              <li>
                Die Vereinbarung ergibt sich aus einem am Ende der Buchung
                angegebenen Gesamtpreis. Dies setzt sich aus der Miete und der
                Bearbeitungsgebühr (bestimmter Prozentsatz über der ersten
                Monatsmiete, die neben dem Zimmerpreis angegeben ist) zusammen,
                die eine Verwaltungskomponente und eine durch die Miete
                bestimmte immobilienbasierte Komponente umfasst. Nach erfolgter
                Buchung benachrichtigt HousingAnywhere.com die Benutzer über den
                Inhalt und den Gesamtpreis.
              </li>
              <li>
                HousingAnywhere.com behält sich das Recht vor, dem Mieter seine
                Dienste für aufeinanderfolgende Monate anzubieten. Der Service
                von HousingAnywhere.com beschränkt sich nicht nur auf die erste
                Monatsmiete.
              </li>
              <li>
                HousingAnywhere.com ist berechtigt, die Höhe der
                Bearbeitungsgebühren jederzeit zu ändern. Dies gilt nicht für
                bereits abgeschlossene Mietverträge. Der Anbieter wird
                rechtzeitig zusammen mit der Buchungsanfrage per E-Mail über die
                Höhe der Bearbeitungsgebühr informiert.
              </li>
              <li>
                HousingAnywhere.com ist berechtigt, sein Geschäftsmodell so zu
                ändern, dass es auch eine Bearbeitungsgebühr vom Anbieter
                erhebt. Dies zeigt sich in einer Reduzierung der von
                HousingAnywhere.com an den Anbieter übertragenen Miete.
              </li>
              <li>
                Der Mieter muss den in der Buchung angegebenen Gesamtpreis über
                den im Buchungsprozess ausgewählten Kanal bezahlen.
                HousingAnywhere.com erhält nur die Bearbeitungsgebühr, die Miete
                wird zu einem bestimmten Zeitpunkt an den Anbieter überwiesen,
                dessen Einzelheiten unter Punkt 8.3 nachzulesen sind. Wenn der
                Geldeinzug nicht erfolgreich ist, muss der Mieter alle
                zusätzlich anfallenden Kosten erstatten. Dies gilt nicht, wenn
                der Mieter nicht für den fehlgeschlagenen Geldeinzug
                verantwortlich ist.
              </li>
              <li>
                HousingAnywhere.com berechnet dem Anbieter eine Provision. Die
                Provisionsberechnung finden Sie unter Artikel 8.19.
              </li>
              <li>
                Benutzer können die Bearbeitungsgebühren von HousingAnywhere.com
                nur dann mit Forderungen verrechnen, wenn diese fällig und
                gesetzlich festgelegt oder unbestritten sind. Forderungen können
                nicht an Dritte übertragen werden.
              </li>
              <li>
                HousingAnywhere.com nutzt einen Zahlungsdienstleister. Bei
                unterschiedlichen Währungen ermittelt dieser
                Zahlungsdienstleister den Wechselkurs anhand des Marktkurses.
                HousingAnywhere.com ist an der Ermittlung des Wechselkurses
                nicht beteiligt. Im Falle einer Rückerstattung wird der aktuelle
                Wechselkurs herangezogen - unabhängig davon, ob der Wechselkurs
                zum Zeitpunkt der Zahlung anders war. Darüber hinaus haftet der
                Mieter in Rückerstattungsfällen für die Transaktionskosten
                seiner eigenen Bank sowie für etwaige
                Währungsumrechnungsdienste, die seine Bank möglicherweise
                erbringt.
              </li>
            </ol>
          </li>
          <li>
            Auf Anfrage muss der Anbieter dem Mieter eine Rechnung über den
            Gesamtpreis ausstellen. Auf Anfrage stellt HousingAnywhere.com dem
            Anbieter eine Rechnung über die Bearbeitungsgebühr aus, die jedoch
            gemäß den steuerrechtlichen Bestimmungen ohne Umsatzsteuer oder
            ähnliche indirekte Steuern ausgewiesen wird, sofern in diesen
            Bestimmungen nicht ausdrücklich etwas anderes angegeben ist.
          </li>
          <li>
            Sofern HousingAnywhere.com nichts Gegenteiliges mitgeteilt wird,
            wird widerlegbar davon ausgegangen, dass der Anbieter gewerblich
            tätig und sich seiner daraus resultierenden (Umsatz-)
            Steuerpflichten bewusst ist und diese entsprechend erfüllt.
            HousingAnywhere.com ist berechtigt, entsprechende Nachweise über die
            Geschäftsfähigkeit des Anbieters zu verlangen.
          </li>
          <li>
            Der Anbieter behält sich das Recht vor, zusätzlich Vor-Ort-Kosten in
            Abhängigkeit vom Verbrauch und der Nutzung (insbesondere Strom,
            Wasser, Heizung) zu berechnen. Der Anbieter muss dem Mieter vor
            Abschluss des Vertrages mitteilen, dass es sein grundsätzliches
            Recht ist, diese Kosten zu berechnen. Diese Kosten werden bei der
            Berechnung der Buchungsgebühr nicht berücksichtigt.
          </li>
          <li>
            HousingAnywhere.com empfiehlt Nutzern, die sich auf die Anmietung
            einer Unterkunft geeinigt haben, gemeinsam einen Vertrag zu
            unterzeichnen.
          </li>
          <li>
            Wie in Artikel 8.10 erwähnt, wird für jede Buchung eine Provision
            erhoben. Die Provision wurde zuvor zwischen dem Anbieter und
            HousingAnywhere.com vereinbart, der von einem der Account Manager
            vertreten wurde, oder während des Anmeldevorgangs festgelegt.
          </li>
          <li>
            Die Provision wird von der Auszahlung der ersten Monatsmiete
            abgezogen.
          </li>
          <li>
            Die Provision wird je nach Paket auf Basis des Gesamtauftragswertes
            oder als 25 % der ersten Monatsmiete berechnet. Der
            Gesamtauftragswert wird durch die gesamte Anzahl der <u>Tage</u> der
            Buchung bestimmt. (z. B. vom 01.08.2017 bis 31.12.2017 – das sind
            153 Tage)
          </li>
          <li>
            Die Mehrwertsteuer ist NICHT im Mietpreis enthalten und wird daher
            zusätzlich berechnet.
          </li>
          <li>
            Als Beispiel für eine Provision basierend auf dem
            Gesamtauftragswert:
            <br />
            <br />
            <table>
              <tbody>
                <tr>
                  <td>Auftragswert eines ganzen Jahres</td>
                  <td>=</td>
                  <td>Monatsmiete</td>
                  <td>x</td>
                  <td>12 Monate</td>
                </tr>
                <tr>
                  <td>Vertragswert eines Tages</td>
                  <td>=</td>
                  <td>Auftragswert eines ganzen Jahres</td>
                  <td>/</td>
                  <td>365</td>
                </tr>
                <tr>
                  <td>Vertragswert der Buchung</td>
                  <td>=</td>
                  <td>Vertragswert eines Tages</td>
                  <td>x</td>
                  <td>Aufenthaltsdauer/Buchungsdauer</td>
                </tr>
                <tr>
                  <td>Provisionsgebühr</td>
                  <td>=</td>
                  <td>Vertragswert der Buchung</td>
                  <td>x</td>
                  <td>Provision %</td>
                </tr>
                <tr>
                  <td>
                    <strong>Gesamtbetrag auf der Rechnung</strong>
                  </td>
                  <td>
                    <strong>=</strong>
                  </td>
                  <td>
                    <strong>Provisionsgebühr</strong>
                  </td>
                  <td>
                    <strong>+</strong>
                  </td>
                  <td>
                    <strong>Umsatzsteuer</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            Als Beispiel für eine Provision basierend auf 25 % der ersten
            Monatsmiete:
            <br />
            Provision = 0,25 x monatliche Miete
            <br />
            Gesamtbetrag auf der Rechnung = Provision + MwSt.
          </li>
        </ol>
        <h4>Artikel 9: Kaution</h4>
        <ol>
          <li>
            Der Anbieter ist berechtigt, in seinem Angebot eine Kaution zu
            verlangen. Wenn ein Anbieter am Tag der Ankunft vom Mieter eine
            Kaution verlangt, müssen entsprechende Angaben zur Höhe der Kaution
            und zur Zahlungsmethode bereits im Angebot enthalten sein. Die Höhe
            der Kaution muss vor der Buchung festgelegt werden. Es muss auch im
            Voraus geklärt werden, wann der Betrag zu zahlen ist (z. B. beim
            Einzug).
          </li>
          <li>
            Wenn der Anbieter die Kaution in der Anzeige für seine Unterkunft
            nicht erwähnt hat, aber zu einem späteren Zeitpunkt eine Kaution
            verlangt und der Mieter nicht zustimmt, stellt dies eine Weigerung
            des Anbieters dar, die Leistung gemäß dem vereinbarten Vertrag zu
            erbringen. In solchen Fällen behält sich der Mieter das Recht vor,
            die Buchung zu stornieren, wonach der Anbieter verpflichtet ist, die
            bereits gezahlte Miete zu erstatten.
          </li>
          <li>
            Housing Anywhere ist nicht verantwortlich für die Verwaltung von
            Sicherheitsleistungen oder für Ansprüche des Anbieters.
          </li>
          <li>
            Der Anbieter ist für die Rückerstattung der Kaution am Ende des
            Mietverhältnisses an den Mieter verantwortlich.
          </li>
        </ol>
        <h4>Artikel 10: Dauer, Kündigung</h4>
        <ol>
          <li>Der Vertrag wird auf unbestimmte Zeit abgeschlossen.</li>
          <li>
            Der Nutzer kann den Vertrag jederzeit ohne vorherige Ankündigung
            kündigen. Mietverträge des Benutzers mit anderen Benutzern, die
            bereits nachgewiesen oder vereinbart wurden, bleiben von der
            Kündigung der Nutzungsvereinbarung unberührt. Dies gilt entsprechend
            für Ansprüche auf Zahlung bereits fälliger Bearbeitungsgebühren.
          </li>
          <li>
            Housing Anywhere kann die Nutzungsvereinbarung jederzeit mit einer
            Frist von zwei Wochen kündigen. Dafür ist eine E-Mail ausreichend.
          </li>
          <li>
            Das Sperrrecht, das Kündigungsrecht aus wichtigem Grund oder die
            individuell vereinbarten Kündigungsrechte des Benutzers bleiben
            hiervon unberührt. Insbesondere steht Housing Anywhere ein
            Kündigungsrecht aus wichtigem Grund zu, wenn:
            <ul>
              <li>
                der Benutzer nicht einmal einer unwesentlichen
                Zahlungsverpflichtung weder ganz noch teilweise nachkommt,
                obwohl er eine Mahnung mit einer angemessenen Frist erhalten
                hat;
              </li>
              <li>
                der Benutzer gegen seine Verpflichtungen aus diesen Allgemeinen
                Geschäftsbedingungen verstößt und keine Abhilfemaßnahmen
                ergreift, obwohl er eine Mahnung mit einer angemessenen Frist
                erhalten hat. Eine Mahnung ist nicht erforderlich, wenn nicht
                davon ausgegangen wird, dass diese erfolgreich wäre, oder wenn
                der Verstoß so schwerwiegend ist, dass es für Housing Anywhere
                unangemessen wäre, die Vereinbarung aufrechtzuerhalten.
              </li>
              <li>
                aufgrund gesetzlicher, gerichtlicher oder behördlicher
                Anforderungen die Nutzung der Plattform in dieser Form nicht
                mehr angeboten werden kann;
              </li>
              <li>
                Housing Anywhere seine Plattform- oder Geschäftsaktivitäten
                einstellt;
              </li>
              <li>
                aufgrund fehlender Mittel ein Insolvenzverfahren über das
                Vermögen des Benutzers eingeleitet wird.
              </li>
            </ul>
          </li>
        </ol>
        <h4>
          Artikel 11: Maßnahmen bei rechtswidrigem Verhalten und/oder
          vertragswidrigem Verhalten durch den Benutzer
        </h4>
        <ol>
          <li>
            Bestehen konkrete Anhaltspunkte dafür, dass ein Benutzer vorsätzlich
            gegen gesetzliche Bestimmungen, Rechte Dritter oder die Allgemeinen
            Geschäftsbedingungen verstößt oder hat Housing Anywhere sonst ein
            berechtigtes Interesse, insbesondere im Hinblick auf den Schutz
            seiner Benutzer vor betrügerischen Aktivitäten, so kann Housing
            Anywhere eine oder mehrere der folgenden Maßnahmen vorbehaltlich
            einer fristlosen Kündigung ergreifen:
            <ul>
              <li>dem Benutzer eine Warnung erteilen;</li>
              <li>die Angebote des Benutzers oder andere Inhalte löschen;</li>
              <li>die Nutzung der Website durch den Benutzer einschränken;</li>
              <li>
                den Benutzer vorübergehend oder dauerhaft von der Website
                ausschließen (blockieren);
              </li>
              <li>
                bestehende Mietverträge im Namen des Anbieters ohne
                Berücksichtigung sonstiger geltender Kündigungsrichtlinien
                anfechten und kündigen sowie Angebote des Benutzers zum
                Abschluss eines Mietvertrags im Namen des Anbieters ablehnen.
              </li>
            </ul>
          </li>
          <li>
            Housing Anywhere berücksichtigt bei der Auswahl dieser Maßnahmen
            auch die berechtigten Interessen des betreffenden Benutzers.
          </li>
          <li>
            Bereits zwischen dem Benutzer und anderen Benutzern abgeschlossene
            Mietverträge sind von der Löschung eines Angebots nicht betroffen.
            Dies gilt entsprechend für Ansprüche auf Zahlung bereits fälliger
            Bearbeitungsgebühren. Es kommt kein wirksamer Mietvertrag zustande,
            wenn Housing Anywhere ein Angebot löscht, bevor es angenommen wird.
          </li>
          <li>
            Housing Anywhere hat das Recht, einen Benutzer in jedem der
            folgenden Fälle dauerhaft zu blockieren. Soweit zumutbar, erhält der
            Benutzer eine vorherige Warnung von Housing Anywhere, damit er die
            Möglichkeit hat, den Verdacht zu zerstreuen oder Abhilfemaßnahmen zu
            ergreifen. Wenn eine vorherige Warnung nicht sinnvoll ist, z. B.
            weil eine Blockierung erforderlich ist, um Schäden für Housing
            Anywhere oder einen anderen Benutzer zu verhindern, wird der
            Benutzer anschließend von Housing Anywhere sofort über die
            Blockierung informiert und erhält dann die Möglichkeit, Kommentare
            abzugeben und Abhilfemaßnahmen zu ergreifen. Das Recht, einen
            Benutzer zu blockieren, besteht, wenn:
            <ul>
              <li>
                der Benutzer in seinem Benutzerkonto falsche
                Kontaktinformationen angegeben hat, insbesondere eine falsche
                oder ungültige E-Mail-Adresse;
              </li>
              <li>ein Benutzerkonto an eine andere Partei übertragen wird;</li>
              <li>
                der Benutzer anderen Benutzern erheblich schadet, insbesondere
                wenn seine Unterkünfte und/oder Möbel beschädigt, zerstört,
                gestohlen usw. sind;
              </li>
              <li>
                es einen triftigen Grund für ein ähnliches Risiko und eine
                ähnliche Verantwortung des Benutzers gibt.
              </li>
            </ul>
          </li>
          <li>
            Nachdem ein Benutzer von Housing Anywhere dauerhaft gesperrt wurde,
            hat er keinen Anspruch auf Wiederherstellung des gesperrten
            Benutzerkontos. Dem Benutzer ist es auch nicht mehr gestattet, die
            Website mit anderen Benutzerkonten zu nutzen oder sich erneut zu
            registrieren.
          </li>
          <li>
            Der Benutzer haftet für Schäden, die Housing Anywhere durch einen
            Verstoß gegen diese Allgemeinen Geschäftsbedingungen entstehen.
            Housing Anywhere kann seine im Rahmen dieser Allgemeinen
            Geschäftsbedingungen verursachten Schäden gegen den Benutzer geltend
            machen. Darüber hinaus bewahrt der Benutzer Housing Anywhere vor
            Ansprüchen Dritter im Zusammenhang mit Verstößen des Benutzers gegen
            die Allgemeinen Geschäftsbedingungen.
          </li>
        </ol>
        <h4>Artikel 12: Gespräche über Housing Anywhere</h4>
        <ol>
          <li>
            Wir erheben Daten aus Gesprächen, die auf unserer
            Messaging-Plattform über das Inbox-Fenster der
            HousingAnywhere-Website stattfinden. Einer der Hauptgründe für die
            Datenerfassung ist die Betrugsprävention und Sicherheit unserer
            Benutzer. Weitere Informationen darüber, wie und warum wir diese
            Daten erfassen, finden Sie in unserer Datenschutzerklärung.
          </li>
          <li>
            Alle anderen Informationen, die Housing Anywhere über die Website
            sammelt, verwendet und speichert, werden in Übereinstimmung mit den
            entsprechenden Gesetzen und Vorschriften verwendet und gespeichert.
          </li>
          <li>
            Im Streitfall zwischen Mieter und Anbieter kann Housing Anywhere
            beiden Parteien auf Anfrage den Chatverlauf zur Verfügung stellen.
          </li>
        </ol>
        <h4>Artikel 13: Haftung von Housing Anywhere</h4>
        <ol>
          <li>
            Housing Anywhere haftet in vollem Umfang für Schäden, die durch
            Vorsatz oder grobe Fahrlässigkeit von Housing Anywhere, seinen
            Mitarbeitern oder Vertretern verursacht wurden, für die
            betrügerische Verschleierung von Mängeln und für den Fall, dass
            ausdrücklich eine Garantie übernommen wurde.
          </li>
          <li>
            Housing Anywhere haftet für andere Schäden nur, wenn sie sich aus
            einer Pflichtverletzung ergeben, deren Erfüllung die ordnungsgemäße
            Umsetzung der Vereinbarung ermöglicht und auf deren Einhaltung von
            den Vertragsparteien regelmäßig vertraut wird. Seine
            Entschädigungspflicht beschränkt sich auf solche Schäden, die als
            vertragstypisch und vorhersehbar gelten.
          </li>
          <li>
            Da Housing Anywhere nicht am Vertragsverhältnis zwischen Mieter und
            Anbieter beteiligt ist, übernimmt Housing Anywhere keine Haftung für
            Verträge, die die Unterkunft betreffen.
          </li>
          <li>
            Housing Anywhere bietet die Möglichkeit, Housing Anywhere mit einer
            Beschwerde zu kontaktieren, wenn Probleme mit der Website, der
            Unterkunft oder dem Anbieter auftreten. Die Beschwerde muss
            schriftlich (per E-Mail) eingereicht werden. In dieser Beschwerde
            muss der Gast ausdrücklich die Gründe für die Beschwerde angeben. In
            einem solchen Fall wird Housing Anywhere versuchen, eine Lösung zu
            finden.
          </li>
        </ol>
        <h4>Artikel 14: Stornierung einer Buchung – Vertragsstrafe</h4>
        <ol>
          <li>
            Für Mieter und Inserenten, die die Buchung innerhalb von 24 Stunden,
            nach denen die ursprüngliche Buchung durchgeführt wurde, stornieren
            möchten:
            <ul>
              <li>Inserenten zahlen keine Strafe</li>
              <li>Mieter erhalten ihr Geld für die erste Monatsmiete zurück</li>
            </ul>
          </li>
          <li>
            Die Rückerstattungsgarantie für Mieter unter Punkt 1 beinhaltet
            nicht die Buchungsgebühr, es sei denn, das Zimmer:
            <ul>
              <li>wurde doppelt gebucht</li>
              <li>ist nicht verfügbar</li>
            </ul>
          </li>
          <li>
            Die Rückerstattungsgarantie des Mieters – unter der unter Punkt 2
            genannten Einschränkung – wird so bald wie möglich, spätestens
            jedoch 30 Tage nach Aufhebung der Buchung, zurückerstattet.
          </li>
          <li>
            Die Stornierung sollte ausschließlich per Brief oder E-Mail
            erfolgen.
          </li>
          <li>
            Bei Stornierung der Buchung nach dem Tag der Buchung wird eine
            Vertragsstrafe erhoben.
          </li>
          <li>
            Storniert ein Inserent eine Buchung nach dem Tag der Buchung
            aufgrund einer falschen Zimmerverfügbarkeit oder einer persönlichen
            Präferenz eines Mieters, wird eine mehrstufige Strafe verhängt:
            <ul>
              <li>
                Stufe 1: Nach der ersten Stornierung wird die Anzeige des
                Inserenten für einen Zeitraum von 2 Wochen an das Ende der Liste
                auf der Suchseite der betreffenden Stadt verschoben;
              </li>
              <li>
                Stufe 1: Nach der ersten Stornierung wird die Anzeige des
                Inserenten für einen Zeitraum von 2 Wochen an das Ende der Liste
                auf der Suchseite der betreffenden Stadt verschoben;
              </li>
            </ul>
          </li>
          <li>
            Wenn ein Mieter eine Buchung nach dem Tag der Buchung aufgrund eines
            erhöhten Preises storniert, gilt auch die mehrstufige Strafe
          </li>
          <li>
            Storniert ein Mieter eine Buchung nach dem Tag der Buchung aus
            anderen Gründen als höherer Gewalt, behält Housing Anywhere die
            Buchungsgebühr als Entschädigung für seine Dienstleistungen ein.
          </li>
          <li>
            Der Inserent des Mieters wird schriftlich oder per E-Mail
            informiert, wenn eine Vertragsstrafe erhoben wird.
          </li>
        </ol>
        <h4>Artikel 15: Empfehlung für Benutzer</h4>
        <ol>
          <li>
            Housing Anywhere empfiehlt Benutzern, eine vertragliche Vereinbarung
            miteinander zu treffen. Wie bereits erwähnt, ist HousingAnyshere.com
            nicht an der Vereinbarung zwischen Anbieter und Mieter beteiligt und
            rät beiden Parteien daher, eine vertragliche Vereinbarung
            miteinander zu schließen. Housing Anywhere bietet auf seiner Website
            einen Vertragsentwurf an, garantiert jedoch nicht die
            Vollständigkeit dieses Vertrags.
          </li>
          <li>
            Housing Anywhere rät dem Mieter außerdem, eine
            Haftpflichtversicherung zur Deckung der Kosten für den Fall
            abzuschließen, dass Schäden an der Unterkunft entstehen.
          </li>
        </ol>
        <h4>Artikel 16: Schlussbestimmungen</h4>
        <ol>
          <li>
            Housing Anywhere ist berechtigt, seine Rechte und Pflichten aus
            dieser Vereinbarung ganz oder teilweise auf Dritte zu übertragen.
          </li>
          <li>
            Housing Anywhere ist berechtigt, seinen Benutzern über einen
            Newsletter Mailings über Nebenerwerb, Jobs und Praktika bei Housing
            Anywhere zu senden. Benutzer haben die Möglichkeit, sich von diesem
            Newsletter abzumelden.
          </li>
          <li>
            Diese Vereinbarung unterliegt ausschließlich dem Sachrecht des
            Königreichs der Niederlande mit Ausnahme des Übereinkommens der
            Vereinten Nationen über Verträge über den internationalen Warenkauf
            sowie dem niederländischen internationalen Privatrecht.
          </li>
          <li>
            Handelt es sich bei dem Benutzer um einen Verbraucher im Sinne von
            Buch 7 des Burgerlijk Wetboek (BW - Niederländisches
            Zivilgesetzbuch), hat dies keine Auswirkungen auf die verbindlichen
            Verbraucherschutzbestimmungen, in denen der Verbraucher seinen
            gewöhnlichen Aufenthalt hat.
          </li>
          <li>
            Wenn einzelne Bestimmungen dieser Allgemeinen Geschäftsbedingungen
            ganz oder teilweise ungültig sind oder werden, bleiben die anderen
            Allgemeinen Geschäftsbedingungen weiterhin gültig. Sollte eine
            solche Bestimmung ungültig sein, wird sie durch eine gesetzliche
            Bestimmung ersetzt.
          </li>
          <li>
            Alle Erklärungen, die im Zusammenhang mit der mit Housing Anywhere
            zu schließenden Nutzungsvereinbarung zu senden sind, müssen per
            E-Mail zugestellt werden. Die Postanschrift und E-Mail-Adresse eines
            Benutzers sind diejenigen, die als aktuelle Kontaktdaten im
            Benutzerkonto des Benutzers angegeben sind.
          </li>
          <li>
            Diese Allgemeinen Geschäftsbedingungen werden in Übereinstimmung mit
            dem niederländischen Recht ausgelegt. Sie und Housing Anywhere
            erklären sich damit einverstanden, sich der Zuständigkeit des
            Gerichts in Rotterdam, Niederlande, für alle Klagen zu unterwerfen,
            bei denen die Parteien vor einem zuständigen Gericht
            Unterlassungsansprüche oder andere billigkeitsrechtliche
            Rechtsbehelfe beantragen.
          </li>
        </ol>
      </li>
    </ul>
  );
}

export default Terms;
